import classNames from 'classnames';
import { Checkbox } from 'components/Checkbox/Checkbox';
import { Spinner } from 'components/Spinner/Spinner';
import type { ChangeEvent, ReactNode } from 'react';

import './Accept.scss';

type AcceptProps = {
  checked?: boolean;
  children: ReactNode;
  className?: string;
  dataTestId?: string;
  error?: boolean | string;
  isLoading?: boolean;
  name: string;
  readOnly?: boolean;
  required?: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: ChangeEvent<HTMLInputElement>) => void;
};

const Accept = ({
  checked = false,
  children,
  className,
  dataTestId = 'checkbox',
  error,
  isLoading = false,
  name,
  readOnly = false,
  required = false,
  onChange,
  onBlur,
}: AcceptProps) => {
  return (
    <div
      className={classNames('FormGroup FormGroup--block', {
        'has-error': error,
      })}
    >
      <div className={classNames('Accept', className)}>
        {isLoading ? (
          <div className="flex items-center pl-3 pr-3 pt-3 pb-3">
            <Spinner
              className="!w-10 !h-10 !max-w-10 !max-h-10 !m-0 scale-[0.35] origin-top-left"
              data-testid="accept-loading-spinner"
            />
            <span className="text-gray-950 text-base -ml-1">{children}</span>
          </div>
        ) : (
          <Checkbox
            checked={checked}
            data-testid={dataTestId}
            error={error}
            label={children}
            name={name}
            onBlur={onBlur}
            onChange={onChange}
            readOnly={readOnly}
            required={required}
          />
        )}
      </div>
    </div>
  );
};

export { Accept };
